import React from "react";
import styles from "./styles.module.scss";
const ClearTrainingButton = ({
  onClear,
  disabled,
  children = "X",
  ...props
}) => (
  <button
    type="button"
    onClick={onClear}
    disabled={disabled}
    className={styles.button}
    {...props}
  >
    {children}
  </button>
);

export default ClearTrainingButton;
